import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Download, Loader2 } from "lucide-react";

export default function Downloads() {
  const { user, loading: authLoading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { setLoading(false); return; }
    api.get("/my/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, [user, authLoading]);

  const downloadItem = async (order, item) => {
    try {
      const { data } = await api.get(`/download/${order.id}/${item.product_id}/${item.format}`);
      window.open(data.download_url, "_blank");
    } catch (e) { console.error(e); }
  };

  if (authLoading || loading) return <div className="max-w-5xl mx-auto px-6 py-20"><Loader2 className="animate-spin text-[#D4AF37]" /></div>;
  if (!user) {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center">
        <h1 className="font-serif-display text-3xl text-white">Sign in to see your downloads</h1>
        <Link to="/login" className="btn-gold mt-6 inline-block px-6 py-3 rounded text-xs tracking-widest uppercase">Sign In</Link>
      </div>
    );
  }

  const paidOrders = orders.filter((o) => o.payment_status === "paid");

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16" data-testid="downloads-page">
      <div className="label-eyebrow mb-3">Your Library</div>
      <h1 className="font-serif-display text-5xl text-white">Downloads & <span className="italic text-[#D4AF37]">orders</span></h1>
      {paidOrders.length === 0 ? (
        <p className="text-neutral-400 mt-10">You haven't purchased anything yet. <Link to="/music" className="text-[#D4AF37]">Browse music</Link>.</p>
      ) : (
        <div className="mt-12 space-y-6">
          {paidOrders.map((o) => (
            <div key={o.id} className="luxury-card rounded-xl p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="label-eyebrow">Order #{o.id.slice(0, 8)}</div>
                <div className="text-xs text-neutral-500">{new Date(o.created_at).toLocaleDateString()}</div>
              </div>
              <div className="space-y-3">
                {o.items.map((i) => (
                  <div key={`${i.product_id}-${i.format}`} className="flex items-center justify-between border-b border-white/10 pb-3 last:border-0">
                    <div>
                      <div className="text-white">{i.title}</div>
                      <div className="text-xs tracking-widest uppercase text-neutral-500">{i.format} · £{Number(i.price).toFixed(2)}</div>
                    </div>
                    <button onClick={() => downloadItem(o, i)} className="btn-ghost-gold px-4 py-2 rounded text-xs tracking-widest uppercase inline-flex items-center gap-2">
                      <Download size={14} /> Download
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
